<section id="advisory">

  <i class="fas speaker-icon fa-users text-center"></i>
  <h2 class="section-heading">Advisory Committee</h2>
  <h2 class="section-heading mt-5">National</h2>
  <ul class="list-group text-center">
	<li class="list-group-item">G. Madhusudhan Reddy, Director, DMRL, Hyderabad</li>
	<li class="list-group-item">B.K. Dhindaw, IITBBS, India</li>
	<li class="list-group-item">G. D. Janaki Ram, IITH, India</li>
	<li class="list-group-item">Satyam Suwas, IISc, India</li>
	<li class="list-group-item">R. Jayaganthan, IIT Madras</li>
	<li class="list-group-item">A. Murugaiyan, IIT Madras</li>
	<li class="list-group-item">K.P. Karunakaran, IITB, India</li>
	<li class="list-group-item">Arvind Kumar, IITK</li>
	<li class="list-group-item">K.S.V.B. Ramakrishna, Ashok Leyland, Chennai</li>
	<li class="list-group-item">G.V. Sarathkumar, Ashok Leyland, Chennai</li>
	<li class="list-group-item">M. Suryanarayana Reddy, Tata Steel, Chennai</li>
	<li class="list-group-item">Srinivasa Chandra, Ashok Leyland, Chennai</li>
	<li class="list-group-item">M Duraiselvam, NIT Trichy</li>
	<li class="list-group-item">Jatin Bhatt, VNIT, Nagpur</li>
	<li class="list-group-item">P. Susila, Anna University, Chennai</li>
	<li class="list-group-item">Vamsi Krishna, CGCRI, India</li>
	<li class="list-group-item">K. Gopala Krishna, NML, Jamshedpur</li>
  </ul>
  <div class="my-3"/>
  <h2 class="section-heading mt-5">International</h2>
  <ul class="list-group text-center">
	<li class="list-group-item">Lindsay Greer, Cambridge University, UK</li>
	<li class="list-group-item">Jurgen Eckert, Montan University, Austria</li>
	<li class="list-group-item">Manoj Gupta, NUS, Singapore</li>
	<li class="list-group-item">Livio Battezzati, University of Torino, Italy</li>
	<li class="list-group-item">Knut Sorby, NTNU, Norway</li>
	<li class="list-group-item">Laichang Zhang, Edith Cowan University, Australia</li>
	<li class="list-group-item">DongDong Gu,  Nanjing University of Aeronautics and Astronautics, China</li>
	<li class="list-group-item">Lukas Lober, University Esslingen, Germany</li>
	<li class="list-group-item">Stoica Mihai, ETH, Zurich, Switzerland</li>
	<li class="list-group-item">Piter Firgarella, Brazil</li>
	<li class="list-group-item">C. Suryanarayana, USA</li>
	<li class="list-group-item">R.V.S. Prasad, South Africa</li>
  </ul>
  <br/>

</section>
<style>
	section {
		padding-top: 86px;
		text-align: center;
	}
	i {
		display: block;
		margin: 0 auto;
		font-size: 2rem;
		padding-bottom: 1em;
	}
	h2 {
		text-align: center;
	}
	p {
		text-align: center;
		width: 80%;
		margin: 0 auto;
		font-size: 1.1em;
	}

	@media all and (min-width: 768px) {
	  p {
	    width: 60%;
	  }
	}
	li {
		font-weight: bold;
	}
</style>
